import utility from "core/Utils";
import { useEffect, useRef } from "react";
import { useState } from "react";
import Input from "./Input";

const MonthInput = props => {
  const [dateValue, setDateValue] = useState(props.value ? props.value : "");
  const dateRef = useRef(null);

  const handleChange = e => {
    console.log(e.target.value);
    setDateValue(e.target.value);
    if (props.onChange !== undefined) {
      try {
        props.onChange(e.target.value);
      } catch (error) {
        console.warn(`onChange not provided on MonthInput`);
      }
    }
  };

  useEffect(() => {
    if (props.value !== dateValue) {
      setDateValue(props.value);
    }
  });

  return (
    <div className="spot-date-input" style={{ ...props.style }}>
      <input
        type="month"
        ref={dateRef}
        value={dateValue}
        onChange={handleChange}
        min={props.min ? props.min : ""}
        max={props.max ? props.max : ""}
      />
      <Input
        disabled={props.disabled ? true : false}
        type="text"
        value={
          dateValue.length
            ? props.customFormat
              ? props.customFormat(dateValue)
              : utility.formatDate(dateValue)
            : ""
        }
        onFocus={e => {
          e.preventDefault();
          dateRef.current.showPicker();
        }}
        onChange={_ => {}}
        placeholder={props.placeholder ? props.placeholder : "Select date"}
      />
    </div>
  );
};

export default MonthInput;
